import { BoundingBox, CategorizedData, DisaggregatedMetric, GeoDetails, GeoTag, Metric, MetricMetadata } from "../services/types";

import houseCostBurden from '../assets/housing-cost-burden.svg';

import populationSvg from '../assets/pop-blue.svg';
import descentSvg from '../assets/descent-group.svg';
import globeSvg from '../assets/foreign-globe.svg';
import limitedEnglishSvg from '../assets/limited-english.svg';
import disabledSvg from '../assets/individuals-with-disabilities.svg';

import healthSvg from '../assets/insurance.svg';
import homeOwnershipSvg from '../assets/home-ownership.svg';
import busSvg from '../assets/bus-icon 1.svg';
import hsgradSvg from '../assets/highschool-grad.svg';
import transitCommuteSvg from '../assets/transit-commute.svg';

import povertySvg from '../assets/poverty-rate.svg';
import povertyRateSvg from '../assets/200-poverty-rate.svg';
import unemploymentSvg from '../assets/unemployment-rate.svg';
import incomeSvg from '../assets/income.svg';

import jobsSvg from '../assets/jobs.svg';

import pedestrianSvg from '../assets/pedestrian.svg';
import internetSvg from '../assets/internet.svg';
import voterSvg from '../assets/voter-participation.svg';
import healthyFoodSvg from '../assets/healthy-food.svg';
import autoToJobsSvg from '../assets/auto-to-jobs.svg';
import transitToJobsSvg from '../assets/transit-to-jobs.svg';
import walkabilitySvg from '../assets/walkabilityindex.svg';

import dieselSvg from '../assets/diesel-emissions.svg';
import pmSvg from '../assets/particulate-matter.svg';
import toxicSvg from '../assets/toxic.svg';
import asthmaSvg from '../assets/asthma.svg';
import trafficSvg from '../assets/high-traffic.svg';
import treeCanopySvg from '../assets/urban-tree-canopy.svg';
import heatTempSvg from '../assets/heat-and-temp.svg';
import noisePollutionSvg from '../assets/noise-pollution.svg';
import floodRiskSvg from '../assets/flood-risk.svg';

//SVGR Imports
import houseCostBurdenIcon from '../assets/svgr/port/housing-cost-burden.svg?react'

import populationIcon from '../assets/svgr/port/pop-blue.svg?react';
import descentIcon from '../assets/svgr/port/descent-group.svg?react';
import globeIcon from '../assets/svgr/port/foreign-globe.svg?react';
import limitedEnglishIcon from '../assets/svgr/port/limited-english.svg?react';
import disabledIcon from '../assets/svgr/port/individuals-with-disabilities.svg?react';

import healthIcon from '../assets/svgr/port/insurance.svg?react';
import homeOwnershipIcon from '../assets/svgr/port/home-ownership.svg?react';
import busIcon from '../assets/svgr/port/bus-icon 1.svg?react';
import hsgradIcon from '../assets/svgr/port/highschool-grad.svg?react';
import transitCommuteIcon from '../assets/svgr/port/transit-commute.svg?react';

import povertyIcon from '../assets/svgr/port/poverty-rate.svg?react';
import povertyRateIcon from '../assets/svgr/port/200-poverty-rate.svg?react';
import unemploymentIcon from '../assets/svgr/port/unemployment-rate.svg?react';
import incomeIcon from '../assets/svgr/port/income.svg?react';

import jobsIcon from '../assets/svgr/port/jobs.svg?react';

import pedestrianIcon from '../assets/svgr/port/pedestrian.svg?react';
import internetIcon from '../assets/svgr/port/internet.svg?react';
import voterIcon from '../assets/svgr/port/voter-participation.svg?react';
import healthyFoodIcon from '../assets/svgr/port/healthy-food.svg?react';
import autoToJobsIcon from '../assets/svgr/port/auto-to-jobs.svg?react';
import transitToJobsIcon from '../assets/svgr/port/transit-to-jobs.svg?react';
import walkabilityIcon from '../assets/svgr/port/walkabilityindex.svg?react';

import dieselIcon from '../assets/svgr/port/diesel-emissions.svg?react';
import pmIcon from '../assets/svgr/port/particulate-matter.svg?react';
import toxicIcon from '../assets/svgr/port/toxic.svg?react';
import asthmaIcon from '../assets/svgr/port/asthma.svg?react';
import trafficIcon from '../assets/svgr/port/high-traffic.svg?react';
import treeCanopyIcon from '../assets/svgr/port/urban-tree-canopy.svg?react';
import heatTempIcon from '../assets/svgr/port/heat-and-temp.svg?react';
import noisePollutionIcon from '../assets/svgr/port/noise-pollution.svg?react';
import floodRiskIcon from '../assets/svgr/port/flood-risk.svg?react';


import { indicatorsEnv, metricsEnv } from "./environment";


// #region Organization Metric Mapping
const organizationMetrics: { [orgId: number]: any[] } =
{ 
    // Port of Seattle
    9:
    [
        {
            name: "Demographics",
            ids: [346, 348, 349, 352, 354, 355, 1180],
            order: [
                [352, 346],
                [348, 349]
            ],
            charts: [
                {
                    name: "raceethnicity",
                    id: 354
                },
                {
                    name: "homelanguage",
                    id: 355
                },
                {
                    name: "immigration",
                    id: 1180
                }
            ]
        },
        {
            name: "Livability",
            ids: [318, 334, 335, 336, 338, 339, 340, 341, 342, 343, 1286, 1121],
            order: [
                [339, 334, 341],
                [335, 318], 
                [340, 1286, 1121, 336],
                [338, 342],
            ],
            charts: [
                {
                    name: "crimerisk",
                    id: 343
                },
            ]
        },
        {
            name: "Accessibility",
            ids: [315, 316, 317, 319, 320, 321, 344, 1153, 1154, 1155],
            order: [
                [320, 344, 315, 321, 1154, 1155, 1153],
                [317, 319, 316]
            ],
            charts: []
        },
        {
            name: "Economy",
            ids: [322, 323, 324, 325, 326, 327, 328, 1156],
            order: [
                [324, 322, 327, 1156],
            ],
            charts: [
                {
                    name: "ged",
                    id: 325
                },
                {
                    name: "bachelors",
                    id: 323
                },
                {
                    name: "masters",
                    id: 326
                },
                {
                    name: "estimatedjobs",
                    id: 328
                },
            ]
        },
        {
            name: "Environment",
            ids: [329, 330, 331, 333, 1121, 1122, 1174, 1175, 1176],
            order: [
                [331, 330, 329, 333, 1121, 1122, 1174, 1175, 1176],
            ],
            charts: []
        }
    ]
};

// precisionMapping - maps metricId's to the desired number of significant figures for formatting metric values
export const precisionMapping: { [metricId: number]: number } = {
    318: 0,
    334: 0,
    335: 0,
    336: 0,
    338: 0,
    339: 0,
    340: 0,
    341: 0,
    342: 0,
    343: 0,
    1286: 0,
    330: 0,
    333: 0,
    1121: 1,
    1122: 0,
    1174: 1,
    1175: 1,
    1176: 1,
    322: 1,
    324: 1,
    327: 0,
    328: 0,
    1156: 1,
    346: 0,
    348: 0,
    349: 0,
    352: 0,
    354: 0,
    355: 0,
    320: 1,
    1154: 1,
    1155: 1,
    315: 0,
    316: 0,
    317: 0,
    319: 0,
    321: 0,
    344: 0,
    323: 0,
    325: 0,
    326: 0,
};

// Identify metrics included in the index
export const indexMetricIds: number[] = [318, 335, 339, 340, 343, 1286, 315, 317, 320, 321, 344, 322, 323, 324, 327, 328, 329, 330, 331, 333, 1122, 1174, 1175, 1176];


const svgMap: { [orgId: number]: { [key: number]: string }} =
{
    // Port of Seattle
    9: {
        318: busSvg, // Transit Access
        335: hsgradSvg, // HS Grad Rate
        336: homeOwnershipSvg, // Home Ownership Rate
        1286: healthSvg, // Fair or Poor Health
        340: transitCommuteSvg, // Transit Commuters
        346: globeSvg,  // Foreign Born
        352: populationSvg, // Total Population
        349: limitedEnglishSvg, // Limited English
        348: disabledSvg, // Individuals with Disabilities
        354: descentSvg,
        339: houseCostBurden,
        // 336: houseOutlineSvg, 
        // 340: bicycleSvg,
        341: houseCostBurden,
        320: pedestrianSvg, // Pedestrian and Bike Facilities
        344: internetSvg, // Households with Internet
        315: voterSvg, // Four Year Average Voter Participation Rate
        321: healthyFoodSvg, // Healthy Food Availability
        1153: walkabilitySvg, // Walkability Index
        1154: transitToJobsSvg, // Transit to Jobs Index
        1155: autoToJobsSvg, // Auto to Jobs Index
        322: unemploymentSvg, // Unemployment Rate
        324: povertySvg, // Poverty Rate 
        327: incomeSvg, // Median HH Income
        328: jobsSvg, // Estimated Jobs Total
        1156: povertyRateSvg, // 200% Poverty Rate
        329: pmSvg, // PM2.5 Particulates
        330: toxicSvg, // Toxic Releases from Facilities
        331: dieselSvg, // Diesel Emissions
        333: trafficSvg, // Proximity to Heavy Traffic Roadways
        1121: asthmaSvg, // Asthma Rates
        1122: treeCanopySvg, // Urban Tree Canopy
        1174: noisePollutionSvg, // Noise Pollution
        1175: floodRiskSvg, // Flood Risk
        1176: heatTempSvg, // Heat and Temperature
    },
};

// There are svgs that need to be included in the pdf that are excluded in the dashboard
const pdfSvgMap: { [orgId: number]: { [key: number]: string }} =
{
    // Port of Seattle
    9: {
        318: busSvg, // Transit Access
        335: hsgradSvg, // HS Grad Rate
        336: homeOwnershipSvg, // Home Ownership Rate
        1286: healthSvg, // Fair or Poor Health
        340: transitCommuteSvg, // Transit Commuters
        346: globeSvg,  // Foreign Born
        352: populationSvg, // Total Population
        349: limitedEnglishSvg, // Limited English
        348: disabledSvg, // Individuals with Disabilities
        354: descentSvg,
        339: houseCostBurden,
        // 336: houseOutlineSvg, 
        // 340: bicycleSvg,
        341: houseCostBurden,
        320: pedestrianSvg, // Pedestrian and Bike Facilities
        344: internetSvg, // Households with Internet
        315: voterSvg, // Four Year Average Voter Participation Rate
        321: healthyFoodSvg, // Healthy Food Availability
        1153: walkabilitySvg, // Walkability Index
        1154: transitToJobsSvg, // Transit to Jobs Index
        1155: autoToJobsSvg, // Auto to Jobs Index
        322: unemploymentSvg, // Unemployment Rate
        324: povertySvg, // Poverty Rate 
        327: incomeSvg, // Median HH Income
        328: jobsSvg, // Estimated Jobs Total
        1156: povertyRateSvg, // 200% Poverty Rate
        329: pmSvg, // PM2.5 Particulates
        330: toxicSvg, // Toxic Releases from Facilities
        331: dieselSvg, // Diesel Emissions
        333: trafficSvg, // Proximity to Heavy Traffic Roadways
        1121: asthmaSvg, // Asthma Rates
        1122: treeCanopySvg, // Urban Tree Canopy
        1174: noisePollutionSvg, // Noise Pollution
        1175: floodRiskSvg, // Flood Risk
        1176: heatTempSvg, // Heat and Temperature
    },
};

const svgrMap: { [orgId: number]: { [key: number]: React.FC<React.SVGProps<SVGSVGElement>> }} =
{
    // Port of Seattle
    9: {
        318: busIcon, // Transit Access
        335: hsgradIcon, // HS Grad Rate
        336: homeOwnershipIcon, // Home Ownership Rate
        1286: healthIcon, // Fair or Poor Health
        340: transitCommuteIcon, // Transit Commuters
        346: globeIcon,  // Foreign Born
        352: populationIcon, // Total Population
        349: limitedEnglishIcon, // Limited English
        348: disabledIcon, // Individuals with Disabilities
        354: descentIcon,
        339: houseCostBurdenIcon,
        // 336: houseOutlineIcon, 
        // 340: bicycleIcon,
        341: houseCostBurdenIcon,
        320: pedestrianIcon, // Pedestrian and Bike Facilities
        344: internetIcon, // Households with Internet
        315: voterIcon, // Four Year Average Voter Participation Rate
        321: healthyFoodIcon, // Healthy Food Availability
        1153: walkabilityIcon, // Walkability Index
        1154: transitToJobsIcon, // Transit to Jobs Index
        1155: autoToJobsIcon, // Auto to Jobs Index
        322: unemploymentIcon, // Unemployment Rate
        324: povertyIcon, // Poverty Rate 
        327: incomeIcon, // Median HH Income
        328: jobsIcon, // Estimated Jobs Total
        1156: povertyRateIcon, // 200% Poverty Rate
        329: pmIcon, // PM2.5 Particulates
        330: toxicIcon, // Toxic Releases from Facilities
        331: dieselIcon, // Diesel Emissions
        333: trafficIcon, // Proximity to Heavy Traffic Roadways
        1121: asthmaIcon, // Asthma Rates
        1122: treeCanopyIcon, // Urban Tree Canopy
        1174: noisePollutionIcon, // Noise Pollution
        1175: floodRiskIcon, // Flood Risk
        1176: heatTempIcon, // Heat and Temperature
    },
};

// There are svgs that need to be included in the pdf that are excluded in the dashboard
const pdfSvgrMap: { [orgId: number]: { [key: number]: React.FC<React.SVGProps<SVGSVGElement>> }} =
{
    // Port of Seattle
    9: {
        318: busIcon, // Transit Access
        335: hsgradIcon, // HS Grad Rate
        336: homeOwnershipIcon, // Home Ownership Rate
        1286: healthIcon, // Fair or Poor Health
        340: transitCommuteIcon, // Transit Commuters
        346: globeIcon,  // Foreign Born
        352: populationIcon, // Total Population
        349: limitedEnglishIcon, // Limited English
        348: disabledIcon, // Individuals with Disabilities
        354: descentIcon,
        339: houseCostBurdenIcon,
        // 336: houseOutlineIcon, 
        // 340: bicycleIcon,
        341: houseCostBurdenIcon,
        320: pedestrianIcon, // Pedestrian and Bike Facilities
        344: internetIcon, // Households with Internet
        315: voterIcon, // Four Year Average Voter Participation Rate
        321: healthyFoodIcon, // Healthy Food Availability
        1153: walkabilityIcon, // Walkability Index
        1154: transitToJobsIcon, // Transit to Jobs Index
        1155: autoToJobsIcon, // Auto to Jobs Index
        322: unemploymentIcon, // Unemployment Rate
        324: povertyIcon, // Poverty Rate 
        327: incomeIcon, // Median HH Income
        328: jobsIcon, // Estimated Jobs Total
        1156: povertyRateIcon, // 200% Poverty Rate
        329: pmIcon, // PM2.5 Particulates
        330: toxicIcon, // Toxic Releases from Facilities
        331: dieselIcon, // Diesel Emissions
        333: trafficIcon, // Proximity to Heavy Traffic Roadways
        1121: asthmaIcon, // Asthma Rates
        1122: treeCanopyIcon, // Urban Tree Canopy
        1174: noisePollutionIcon, // Noise Pollution
        1175: floodRiskIcon, // Flood Risk
        1176: heatTempIcon, // Heat and Temperature
    },
};

// #endregion



// getMetricGroupIds - get the metric id values for a specific grouping 
export const getMetricGroupIds = (name: string) => {

    let ids = [];
    
    if(organizationMetrics[orgId] != undefined){
        const group: any = organizationMetrics[orgId].find((x: { name: string; }) => x.name === name);

        if(group != undefined){
            ids = group.ids;
        }
    }

    return ids;
}

// Store our organization Id where we can access it later
export var orgId: number = 9;
export const setOrgId = (id: number) => {
    orgId = id;
}

// Store our overlapping county fips codes for BLS and TRS data queries
export var countyId: string[] = [];
export const setCountyIds = (id: string[]) => {
    countyId = id;
}
export const getCountyIds = () => {
    return countyId;
}

// Store our bounding box so we can access it later
export let boundingBox: BoundingBox | null = null;
export const setBoundingBox = (bb: BoundingBox) => {
    boundingBox = bb;
}

// Store our excludeIds so we can access them later
export let excludeIds: string[] | null = null;
export const setExcludeIds = (ids: string[]) => {
    excludeIds = ids;
}

// getSvgMap - get our svg mapping for the given organization and metric id
export const getSvgMap = (id: number) => {
    let svg = "";
    if(svgMap[orgId] != undefined){
        svg = svgMap[orgId][id];
    }
    return svg;
}

// getPdfSvgMap - get our pdf svg mapping for the given organization and metric id
export const getPdfSvgMap = (id: number) => {
    let svg = "";
    if(pdfSvgMap[orgId] != undefined){
        svg = pdfSvgMap[orgId][id];
    }
    return svg;
}

// getSvgMap - get our svg mapping for the given organization and metric id
export const getSvgrMap = (id: number): React.FC<React.SVGProps<SVGSVGElement>> | undefined => {
    if(svgrMap[orgId] != undefined){
        return svgrMap[orgId][id];
    }
    return undefined;
}

// getPdfSvgMap - get our pdf svg mapping for the given organization and metric id
export const getPdfSvgrMap = (id: number): React.FC<React.SVGProps<SVGSVGElement>> | undefined => {
    if(pdfSvgrMap[orgId] != undefined){
        return pdfSvgrMap[orgId][id];
    }
    return undefined;
}

// getMetricGroupOrderIds - get the ordering for a metric group
export const getMetricGroupOrderIds = (name: string) => {
    let orderIds = [];
    
    if(organizationMetrics[orgId] != undefined){
        const group: any = organizationMetrics[orgId].find((x: { name: string; }) => x.name === name);

        if(group != undefined){
            orderIds = group.order;
        }
    }

    return orderIds;
}

// getMetricGroupChartId - get a metric id given the group and chart key
export const getMetricGroupChartId = ( group: string, key: string) => {
    let id = -1;

    if(organizationMetrics[orgId] != undefined){
        const g = organizationMetrics[orgId].find((x: { name: string; }) => x.name === group);
        if(g != undefined){
            
            if(g.charts != undefined){

                const chart = g.charts.find((x: { name: string; }) => x.name === key);
                if(chart != undefined){
                    id = chart.id;
                }
            }
        }
    }

    return id;
}

export const categorizeData = (indicators: DisaggregatedMetric[]) => {

    const categories: { [key: string]: number[] } = {
        Demographics: getMetricGroupIds("Demographics"),
        Livability: getMetricGroupIds("Livability"),
        Economy: getMetricGroupIds("Economy"), 
        Accessibility: getMetricGroupIds("Accessibility"),
        Environment: getMetricGroupIds("Environment"),
    };

    // Initialize the categorizedData object dynamically with empty arrays for each category
    const categorizedData: Record<string, Metric[]> = Object.keys(categories).reduce((acc, category) => {
        acc[category] = [];
        return acc;
    }, {} as Record<string, Metric[]>);

    // Categorize the indicators dynamically
    indicators.forEach((item) => {
        Object.keys(categories).forEach((category) => {
            if (categories[category].includes(item.id)) {
                categorizedData[category].push(item);
            }
        });
    });

    return categorizedData;
};

export const fetchMetricCategories = async (orgId: number) => {
    if (!orgId) {
        console.log('No orgId provided to fetch metric metadata');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getmetriccategories?orgId=${orgId}&environment=${metricsEnv}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric metadata:', error);
    }
};

export const fetchMetricMetadata = async (id: number) => {
    if (!id) {
        console.log('No id provided to fetch metric metadata');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getmetricmetadata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id, environment: metricsEnv }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric metadata:', error);
    }
};

export const fetchMetricMetadataByOrg = async (orgId: number) => {
    if (!orgId) {
        console.log('No orgId provided to fetch metric metadata');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getmetadatabyorg`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ orgId, environment: metricsEnv }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.log('Error fetching metric metadata:', error);
    }
};

// fetch PercentileDist - get percentile distribution information by org and category
export const fetchPercentileDist = async (orgId: number, category: string) => {
    if (!orgId || !category) {
        console.log('No orgId or category provided to fetch metric percentile distributions');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getpercentiledist?orgId=${orgId}&category=${category}&environment=${indicatorsEnv}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric metadata:', error);
    }
};

// fetchPercentileById - get percentile distribution information by metric id
export const fetchPercentileById = async (metricId: number) => {
    if (!metricId) {
        console.log('No metricId provided to fetch metric percentile data');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getpercentilebymetric?metricId=${metricId}&environment=${indicatorsEnv}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching percentile data:', error);
    }
};

// fetchDistributionData - get distribution data by metric id and selected area
export const fetchDistributionData = async (metricId: number, geoDetails: GeoDetails[], geoTag: GeoTag | null) => {
    if (!metricId) {
        console.log('No metricId provided to fetch indicator distribution data');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getdistributiondata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ metricId, geoDetails, geoTag, geoEncoding: 'delta', allowDefault: true, environment: indicatorsEnv }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching indicator distribution data:', error);
    }
};

// fetchIndicatorBinCount - get indicator data and bin count by metric id and selected area
export const fetchIndicatorBinCount = async (metricId: number, geoDetails: GeoDetails[], geoTag: GeoTag | null) => {
    if (!metricId) {
        console.log('No metricId provided to fetch indicator distribution data');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getindicatorbincounts`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ metricId, geoDetails, geoTag, geoEncoding: 'delta', allowDefault: true, environment: indicatorsEnv }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching indicator distribution data:', error);
    }
};

// fetchStateData - retreive state data for a selected metric using a prefix state code
export const fetchStateData = async (metricId: number, geoPrefix: string) => {
    if (!metricId || !geoPrefix) {
        console.log('No metricId or geoDetails provided to fetch metric state data');
        return;
    }

    console.log('geoprefix:', geoPrefix);

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getgeoprefixdata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ metricId, geoPrefix, environment: indicatorsEnv }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric state data:', error);
    }
};

// fetchNationalData - retreive national data for a selected metric
export const fetchNationalData = async (metricId: number) => {
    if (!metricId) {
        console.log('No metricId provided to fetch national metric data');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getgeoprefixdata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ metricId, environment: indicatorsEnv }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching national metric data:', error);
    }
};

export const calculateGeoPrefix = (geoDetails: GeoDetails[]): string => {
    // Flatten the geoIds array
    const geoIds = geoDetails.flatMap(geo => geo.ids);

    // Helper function to get the first two digits of a geoId
    const getGeoPrefix = (geoId: string): string => geoId.substring(0, 2);

    // Count occurrences of each prefix
    const prefixCount: Record<string, number> = {};
    geoIds.forEach(geoId => {
        const prefix = getGeoPrefix(geoId);
        prefixCount[prefix] = (prefixCount[prefix] || 0) + 1;
    });

    // Find the prefix with the highest count
    return Object.entries(prefixCount).reduce((prev, curr) => 
        curr[1] > prev[1] ? curr : prev, ['', 0]
    )[0];
};

// getMissingMetrics - utility function to check for missing metrics on a given dashboard panel
export const getMissingMetrics = (
    tab: string,
    categorizedData: Metric[],
    indicators: DisaggregatedMetric[] | null
  ): string => {
    if (!indicators) return '';
  
    const missingMetrics = indicators?.filter(metric => 
        metric.category?.toLowerCase() === tab.toLowerCase() && 
        !categorizedData.some(data => data.id === metric.id)
    ) || [];    
  
    return missingMetrics.map(metric => metric.name).join(", ");
};

// Helper function to get and sort metrics by category
export const getSortedMetrics = (category: string, categorizedData: CategorizedData) => {
    const orders = getMetricGroupOrderIds(category);

    return orders.map((order: number[]) => 
        categorizedData[category]
            .filter(metric => order.includes(metric.id))
            .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    );
};

// Helper function to get and sort metrics by category - Used in PDF metrics display
export const getSortedMetricsPDF = (category: string, categorizedData : {
    category: string;
    metrics: DisaggregatedMetric[];
}[]): DisaggregatedMetric[] => {
    const metrics = categorizedData.find(data => data.category === category)?.metrics || [];
    const orders = getMetricGroupOrderIds(category);
    return orders.flatMap((order: number[]) =>
      metrics
        .filter(metric => order.includes(metric.id))
        .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    );
};
  
// Helper function to get the index metric data
export const getIndexMetricData = (
    category: string, 
    metadata: MetricMetadata[] | null, 
    disaggregatedData: DisaggregatedMetric[]
): { indexMetricId: number; indexMetricData: DisaggregatedMetric | null } => {
    
    const indexMetricId = metadata?.find(
        (metric) => 
            metric.metric_source_type === "index" && 
            metric.metric_category.toLowerCase() === category.toLowerCase()
    )?.id || 0;

    const indexMetricData = disaggregatedData.find(metric => metric.id === indexMetricId) || null;

    return { indexMetricId, indexMetricData };
};

// Helper function to get the index metric data - Formatted for PDF (MetricModal) use.
export const getIndexMetricDataPDF = (category: string, metadata: MetricMetadata[] | null, disaggregatedData: DisaggregatedMetric[]): DisaggregatedMetric | null => {
    const indexMetricId = metadata?.find(
        (metric) => metric.metric_source_type === "index" && metric.metric_category.toLowerCase() === category.toLowerCase()
    )?.id || 0;
    return disaggregatedData.find(metric => metric.id === Number(indexMetricId)) || null;
};

